import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ComicBase from "./ComicBase";
import ComicPagina from "./ComicPagina";
import ComicReader from "./ComicReader";
import BusquedaPrecisa from "./BusquedaPrecisa";
import Buscar from "./Buscar";
import Autores from "./Autores";
import Tags from "./Tags";
import Register from "./Registrarse/Register";
import Login from "./Registrarse/Login";
import ScrollToTop from "./ScrollToTop";
import MangaUpload from "./MangaUpload";
import ServerMangaPage from "./ServerMangaPage";
import { apiUrl } from "./mangaApi";

// =====================================================
// 🚀 AUTO-DETECCIÓN DE CÓMICS DESDE /pages
// =====================================================
const context = require.context("./pages", true, /\.jsx$/);

const comicsAuto = context
  .keys()
  .map((file, index) => {
    try {
      const mod = context(file);
      const info = mod.infoManga;
      const Component = mod.default;

      if (!info) return null;

      const enlace =
        info.enlace ||
        `/comic/${info.titulo
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/[^a-z0-9]/g, "")}`;

      return {
        id: index + 1,
        titulo: info.titulo,
        portada: info.portada,
        enlace,
        fecha: info.fecha,
        Component,
      };
    } catch (e) {
      console.error("❌ Error al cargar:", file, e);
      return null;
    }
  })
  .filter(Boolean);

// =====================================================
// 🚀 APP PRINCIPAL
// =====================================================
function App() {
  const [serverComics, setServerComics] = useState([]);

  useEffect(() => {
    let active = true;

    const loadCatalog = () => {
      fetch(apiUrl("/catalog"))
        .then((response) => {
          if (!response.ok) {
            throw new Error("No se pudo cargar el catálogo del servidor.");
          }
          return response.json();
        })
        .then((items) => {
          if (!active) return;
          const catalog = Array.isArray(items) ? items : [];
          setServerComics(
            catalog.map((item) => ({
              id: `server-${item.mangaId}-${item.chapterId}`,
              nombre: item.displayTitle || item.title,
              imagen: item.coverUrl,
              enlace:
                item.detailUrl ||
                `/manga/${item.slug}`,
              fecha: item.createdAt,
              autor: item.author || "",
              mangaId: item.mangaId,
              chapterId: item.chapterId,
              slug: item.slug,
              readerUrl: item.readerUrl,
              esServidor: true,
            }))
          );
        })
        .catch((error) => {
          if (active) {
            console.error("No se pudo cargar el catálogo del VPS:", error);
          }
        });
    };

    loadCatalog();
    window.addEventListener("tmoxnight:catalog-updated", loadCatalog);

    return () => {
      active = false;
      window.removeEventListener("tmoxnight:catalog-updated", loadCatalog);
    };
  }, []);

  const localComics = [...comicsAuto]
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    .map((m) => ({
      id: m.id,
      nombre: m.titulo,
      imagen: m.portada,
      enlace: m.enlace,
    }));

  const comicsLista = [...serverComics, ...localComics];

  return (
    <Router>
      <ScrollToTop />

      <Routes>
        {/* LOGIN */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/subir" element={<MangaUpload />} />

        {/* HOME + PAGINACIÓN */}
        <Route
          path="/"
          element={<ComicPagina comics={comicsLista} />}
        />

        <Route
          path="/page/:num"
          element={<ComicPagina comics={comicsLista} />}
        />

        {/* OTRAS RUTAS */}
        <Route path="/comic" element={<ComicBase />} />
        <Route
          path="/manga/:slug"
          element={<ServerMangaPage suggestions={comicsLista} />}
        />
        <Route path="/lector/:mangaId/:chapterId/:page" element={<ComicReader />} />
        <Route path="/lector/:comicId/:page" element={<ComicReader />} />
        <Route path="/lector/:id" element={<ComicReader />} />
        <Route path="/busqueda-precisa" element={<BusquedaPrecisa />} />
        <Route path="/autores" element={<Autores comics={comicsLista} />} />
        <Route path="/tags" element={<Tags />} />
        <Route path="/buscar" element={<Buscar comics={comicsLista} />} />

        {/* CÓMICS AUTOMÁTICOS */}
        {comicsAuto.map((m, i) => (
          <Route key={i} path={m.enlace} element={<m.Component />} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
